/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Orange_Tiger_HopeInputs */

const en_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional product activations enabled. Click the "Refresh Origin" button to activate in this device.`)
};

const id_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivasi produk tambahan telah diaktifkan. Klik tombol "Refresh Origin" untuk mengaktifkan di device ini.`)
};

const ms_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaktifan produk tambahan didayakan. Klik butang "Muat Semula Origin" untuk mengaktifkan pada peranti ini.`)
};

const ca_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activacions de producte addicionals habilitades. Fes clic al botó "Actualitza Origin" per activar-lo en aquest aparell.`)
};

const cs_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další aktivace produktu povoleny. Kliknutím na tlačítko „Obnovit Origin“ aktivujte na tomto zařízení.`)
};

const da_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yderligere produktaktiveringer aktiveret. Klik på knappen "Opdater Origin" for at aktivere på denne enhed.`)
};

const de_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Produktaktivierungen freigeschaltet. Klicke auf die Schaltfläche „Origin aktualisieren“, um auf diesem Gerät zu aktivieren.`)
};

const et_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täiendavad toote aktiveerimised on lubatud. Klõpsa nupul „Värskenda Origin“, et aktiveerida see seadmes.`)
};

const es_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activaciones adicionales del producto habilitadas. Haz clic en el botón "Actualizar Origin" para activarlo en este dispositivo.`)
};

const fr_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activations supplémentaires du produit activées. Cliquez sur le bouton « Actualiser Origin » pour effectuer l’activation sur cet appareil.`)
};

const hr_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodatne aktivacije proizvoda omogućene. Kliknite gumb "Osvježi Origin" za aktivaciju na ovom uređaju.`)
};

const it_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivazioni aggiuntive del prodotto abilitate. Fai clic sul pulsante "Aggiorna Origin" per attivare su questo device.`)
};

const lv_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iespējotas papildu produkta aktivizācijas. Noklikšķiniet uz pogas "Atsvaidzināt Origin", lai aktivizētu šajā ierīcē.`)
};

const lt_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įjungti papildomi produkto aktyvavimai. Spustelėkite mygtuką „Atnaujinti Origin“, kad aktyvuotumėte šiame įrenginyje.`)
};

const hu_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`További termékaktiválások engedélyezve. Kattints az „Origin frissítése” gombra az aktiváláshoz ezen az eszközön.`)
};

const nl_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra productactiveringen ingeschakeld. Klik op de knop "Origin vernieuwen" om te activeren op dit device.`)
};

const nb_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flere produktaktiveringer aktivert. Klikk på «Oppdater Origin»-knappen for å aktivere på denne enheten.`)
};

const pl_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Włączono dodatkowe aktywacje produktu. Kliknij przycisk "Odśwież Origin", aby aktywować na tym urządzeniu.`)
};

const pt_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativações adicionais do produto habilitadas. Clique no botão "Atualizar Origin" para ativar neste dispositivo.`)
};

const ro_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activări suplimentare ale produsului activate. Fă clic pe butonul „Reîmprospătează Origin” pentru a activa pe acest dispozitiv.`)
};

const sk_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boli povolené ďalšie aktivácie produktu. Kliknite na tlačidlo „Obnoviť Origin“ pre aktiváciu na tomto zariadení.`)
};

const sl_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omogočene so dodatne aktivacije izdelka. Kliknite gumb »Osveži Origin«, da aktivirate na tej napravi.`)
};

const fi_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää tuoteaktivointeja käytössä. Napsauta "Päivitä Origin" -painiketta aktivoidaksesi tämän laitteen.`)
};

const sv_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ytterligare produktaktiveringar har aktiverats. Klicka på knappen "Uppdatera Origin" för att aktivera på den här enheten.`)
};

const vi_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bật thêm các lượt kích hoạt sản phẩm. Nhấp vào nút "Làm mới Origin" để kích hoạt trên thiết bị này.`)
};

const tr_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek ürün etkinleştirmeleri etkinleştirildi. Bu cihazda etkinleştirmek için "Origin'i Yenile" düğmesine tıklayın.`)
};

const el_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ενεργοποιήθηκαν επιπλέον ενεργοποιήσεις προϊόντος. Κάντε κλικ στο κουμπί "Ανανέωση Origin" για ενεργοποίηση σε αυτή τη συσκευή.`)
};

const bg_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допълнителните активирания на продукта са активирани. Щракнете върху бутона „Опресняване на Origin“, за да активирате на това устройство.`)
};

const ru_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные активации продукта включены. Нажмите кнопку «Обновить Origin», чтобы активировать на этом устройстве.`)
};

const sr_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Омогућене су додатне активације производа. Кликните на дугме „Освежи Origin“ да активирате на овом уређају.`)
};

const uk_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Додаткові активації продукту увімкнено. Натисніть кнопку «Оновити Origin», щоб активувати на цьому пристрої.`)
};

const ka_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`პროდუქტის დამატებითი გააქტიურებები ჩართულია. დააწკაპუნეთ "Origin-ის განახლების" ღილაკზე ამ მოწყობილობაზე გასააქტიურებლად.`)
};

const hi_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अतिरिक्त उत्पाद सक्रियण सक्षम। इस डिवाइस में सक्रिय करने के लिए "Origin रिफ्रेश करें" बटन पर क्लिक करें।`)
};

const th_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดใช้งานการเปิดใช้งานผลิตภัณฑ์เพิ่มเติมแล้ว คลิกปุ่ม "รีเฟรช Origin" เพื่อเปิดใช้งานในอุปกรณ์นี้`)
};

const ko_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가 제품 활성화가 활성화되었습니다. "Origin 새로 고침" 버튼을 클릭하여 이 디바이스에서 활성화하세요.`)
};

const zh_tw_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已啟用額外的產品啟用次數。請點擊「重新整理 Origin」按鈕以在此裝置上啟用。`)
};

const ja_bright_orange_tiger_hope = /** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加の製品アクティベーションが有効になりました。「Origin を更新」ボタンをクリックしてこのデバイスでアクティベートしてください。`)
};

/** @type {(inputs: Bright_Orange_Tiger_HopeInputs) => LocalizedString} */
const zh_bright_orange_tiger_hope = en_bright_orange_tiger_hope;

/**
* | output |
* | --- |
* | "Additional product activations enabled. Click the \"Refresh Origin\" button to activate in this device." |
*
* @param {Bright_Orange_Tiger_HopeInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const bright_orange_tiger_hope = /** @type {((inputs?: Bright_Orange_Tiger_HopeInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Orange_Tiger_HopeInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bright_orange_tiger_hope(inputs)
	if (locale === "ms") return ms_bright_orange_tiger_hope(inputs)
	if (locale === "ca") return ca_bright_orange_tiger_hope(inputs)
	if (locale === "cs") return cs_bright_orange_tiger_hope(inputs)
	if (locale === "da") return da_bright_orange_tiger_hope(inputs)
	if (locale === "de") return de_bright_orange_tiger_hope(inputs)
	if (locale === "et") return et_bright_orange_tiger_hope(inputs)
	if (locale === "es") return es_bright_orange_tiger_hope(inputs)
	if (locale === "fr") return fr_bright_orange_tiger_hope(inputs)
	if (locale === "hr") return hr_bright_orange_tiger_hope(inputs)
	if (locale === "it") return it_bright_orange_tiger_hope(inputs)
	if (locale === "lv") return lv_bright_orange_tiger_hope(inputs)
	if (locale === "lt") return lt_bright_orange_tiger_hope(inputs)
	if (locale === "hu") return hu_bright_orange_tiger_hope(inputs)
	if (locale === "nl") return nl_bright_orange_tiger_hope(inputs)
	if (locale === "nb") return nb_bright_orange_tiger_hope(inputs)
	if (locale === "pl") return pl_bright_orange_tiger_hope(inputs)
	if (locale === "pt") return pt_bright_orange_tiger_hope(inputs)
	if (locale === "ro") return ro_bright_orange_tiger_hope(inputs)
	if (locale === "sk") return sk_bright_orange_tiger_hope(inputs)
	if (locale === "sl") return sl_bright_orange_tiger_hope(inputs)
	if (locale === "fi") return fi_bright_orange_tiger_hope(inputs)
	if (locale === "sv") return sv_bright_orange_tiger_hope(inputs)
	if (locale === "vi") return vi_bright_orange_tiger_hope(inputs)
	if (locale === "tr") return tr_bright_orange_tiger_hope(inputs)
	if (locale === "el") return el_bright_orange_tiger_hope(inputs)
	if (locale === "bg") return bg_bright_orange_tiger_hope(inputs)
	if (locale === "ru") return ru_bright_orange_tiger_hope(inputs)
	if (locale === "sr") return sr_bright_orange_tiger_hope(inputs)
	if (locale === "uk") return uk_bright_orange_tiger_hope(inputs)
	if (locale === "ka") return ka_bright_orange_tiger_hope(inputs)
	if (locale === "hi") return hi_bright_orange_tiger_hope(inputs)
	if (locale === "th") return th_bright_orange_tiger_hope(inputs)
	if (locale === "ko") return ko_bright_orange_tiger_hope(inputs)
	if (locale === "zh") return zh_bright_orange_tiger_hope(inputs)
	if (locale === "zh-tw") return zh_tw_bright_orange_tiger_hope(inputs)
	if (locale === "ja") return ja_bright_orange_tiger_hope(inputs)
	return en_bright_orange_tiger_hope(inputs)
});